<template>
  <section class="landing">
    <container>
      <img :src=" general.logo.path " alt="Logo"
           class="landing__logo">
      <h1 class="landing__title">{{ general.title }}</h1>
      <h3 class="landing__subtitle">{{ content.subtitle }}</h3>
      <p class="landing__intro" v-html=" content.text "></p>
    </container>
  </section>
</template>

<script>
  import {api} from '@/main.js'
  import Container from "@/components/container/index";
  export default {
    name: 'OnepageLanding',
    props: ['general'],
    components: {Container},
    data () {
      return {
        content: false
      }
    },
    mounted () {
      api.singleton.get('intro').then(response => {
        this.content = JSON.parse(response.data)
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .landing {
    &__logo {
      display: block;
      margin: 0 auto 2rem;
      width: 20%;
      box-shadow:0 2px 4px 0 rgba(0, 0, 0, 0.23);
    }

    &__title {
      margin: $spacing_title;
      font-size: 1.5 * $size_title-big;
      text-align: center;
    }
    &__subtitle {
      margin: $spacing_title;
      font-size: $size_title-big;
      color: $primary;
      text-align: center;
    }
    &__intro {
      margin: 2rem 4rem 0;
      text-align: center;
      font-size: $size_text-big;
      line-height: 1.75;
    }

    @media (max-width: 777px) {
      &__title { font-size: $size_title-big }
      &__subtitle { font-size: $size_title }
      &__intro { margin: 2rem 0 0; text-align: justify }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/onepage/landing.vue